import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpHelper } from 'src/app/common/http-helper';

export interface SkynetixEmbedResult {
  url: SafeResourceUrl | null;
  errorMessage: string | null;
}

@Injectable()
export class SkynetixAssistantService {
  constructor(
    private httpHelper: HttpHelper,
    private sanitizer: DomSanitizer
  ) {}

  getEmbedUrl(): Observable<SkynetixEmbedResult> {
    return this.httpHelper.getRequest('/skynetix/token').pipe(
      map((res: { embed_url: string }) => ({
        url: this.sanitizer.bypassSecurityTrustResourceUrl(res.embed_url),
        errorMessage: null,
      })),
      catchError((err: HttpErrorResponse) =>
        of({
          url: null,
          errorMessage:
            err?.error?.message ||
            'SkynetiX Assistent ist derzeit nicht verfügbar.',
        })
      )
    );
  }
}
